import { render, staticRenderFns } from "./CompanyRLSGroupListSkeleton.vue?vue&type=template&id=37e2f221"
import script from "./CompanyRLSGroupListSkeleton.vue?vue&type=script&lang=js"
export * from "./CompanyRLSGroupListSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports